import Content from './component';

export default Content;
